import type { SignUpFormDetailsType } from '@/api/contactSignUpForm/data.d';
import type {
  DoubleFormDataType,
  FormErrorInfo,
} from '@/pages/settingManage/utils/typing/doubleOptIn';
import type { CSSProperties } from 'react';
// 提交表单
export interface FormDataType extends SignUpFormDetailsType {}

// 表单 - 报表参数
export interface statisticsParams {
  /** 总人数 */
  total: number;
  /** 已发送 */
  send: number;
  /** 已送达 */
  delivered: number;
  /** 已打开 */
  opened: number;
  /** 无需发送 */
  notSend: number;
  /** 已确认 */
  confirm: number;
  /** 发送失败 */
  failSend: number;
  /** backlog数量 */
  failSendBacklogs: number;
  /** bounce数量 */
  failSendBounce: number;
  /** 拒绝列表过滤数量 */
  blocklistFilterCount: number;
  /** SHLP过滤数量 */
  domainFilterCount: number;
  /** 联系人加入时无需发送 */
  optinSingleNotSend: number;
  /** 联系人地区无需发送 */
  optinRegionNotSend: number;
  /** 一小时内重复提交数量 */
  optinRepeatCommitCount: number;
  /** 其他 */
  otherFilterCount: number;
}

// 步骤枚举
export enum StepEnum {
  // 构建
  BUILD = 1,
  // 设置
  SETTING = 2,
  // 发布
  RELEASE = 3,
}

// 渲染类型
export enum RenderTypeEnum {
  title = 'title',
  input = 'input',
  inputNumber = 'inputNumber',
  textarea = 'textarea',
  select = 'select',
  checkboxGroup = 'checkboxGroup',
  /** 日期选择 */
  date = 'date',
  /** 协议 */
  agreements = 'agreements',
  /** 验证码 */
  captcha = 'captcha',
  /** 按钮 */
  button = 'button',
}

// 构建 - 表单
export type BuildFormDataType = {
  /** 唯一标识 */
  id: any;
  /** 渲染类型 */
  renderType: RenderTypeEnum;
  /** 选中文本 */
  selectedText?: string;
  /** 字段id */
  fieldId: string | number;
  /** 字段 */
  field: string;
  /** 标题 */
  label?: string;
  /** 提示语 */
  placeholder?: string;
  /** 帮助文本 */
  helpText?: string;
  /** 样式 */
  style?: CSSProperties;
  /** 要替换的文本的key */
  replaceTextKey?: string;
  /** 已选值 */
  selectedValue?: any[];
  /** 已选下拉选项 */
  options?: any[];
  config: {
    /** 是否展示label */
    labelFlag?: boolean;
    /** 是否展示placeholder */
    embeddedTextFlag?: boolean;
    /** 是否展示帮助文本 */
    helpTextFlag?: boolean;
    /** 是否必填 */
    required?: boolean;
    /** 是否多选 */
    multiple?: boolean;
    /** 是否展示链接配置 */
    linkConfigFlag?: boolean;
    /** 协议是否展示多选框 */
    checkboxIsShow?: boolean;
    /** 数字类型输入框 宽度 */
    numberWidth?: number;
    /** 工具栏使用的下拉选项 */
    options?: any[];
  };
};

// 构建 - 表单功能操作
export enum BuildFunActionEnum {
  INIT = 'init',
  ADD = 'add',
  INSERT = 'insert',
  EDIT = 'edit',
  REDUCE = 'reduce',
  UP = 'up',
  DOWN = 'down',
}
// 构建 - 表单添加组件功能
export enum BuildAddComponentEnum {
  /** 标题 */
  TITLE = 'title',
  /** 字段 */
  ATTRIBUTE = 'attribute',
  /** 偏好 */
  PREFERENCE = 'preference',
  /** 协议 */
  AGREEMENT = 'agreements',
  /** 验证码 */
  CAPTCHA = 'captcha',
}

// 构建 - 设置表单方法声明
export interface BuildSetSignUpFormDataIF {
  params: any;
  index: number;
  actionType: BuildFunActionEnum;
}

// 构建 - 表单预览模式
export enum BuildPreviewModeEnum {
  DEFAULT = 'default',
  PREVIEW = 'preview',
}
// 构建 - 表单选中文本配置
export type BuildSelectedTextConfig = {
  index: number;
  selectedText: string;
  replaceTextKey: string;
  // 是否链接
  isLink?: boolean;
  // a 标签打开方式 target
  aTarget?: string;
  // a 标签链接 href
  aHref?: string;
};

/** 第二步 - 设置 - 组件传参声明 */
export type SettingCommonPropsType = {
  /** 表单错误信息 */
  formErrorInfo?: FormErrorInfo;
  /** 上次保存的opt-in配置 */
  lastOptInConfig?: DoubleFormDataType;
  /** 是否开启离开页面配置 */
  isLeaveConfig?: boolean;

  /** 设置是否配置默认表单 */
  setIsSetDefaultOptIn?: (val: boolean) => void;
  /** 设置离开页面配置 */
  setLeaveConfig?: (data: { flag?: boolean; goPath?: string }) => void;
};
